/* iFungi purchase-intent popup guard — Copy of Theme 60
 * 2026-10-13 (Claude, Carlo's decision): the Mystery Offer shows again on the homepage and
 * the LF7 / PS7 product pages. The guard used to suppress it whenever a page merely HAD an
 * Add to Cart button. It now steps in only on real purchase intent (pressing Add to Cart,
 * the sticky bar, Checkout, a cart link or a wallet button), on the cart page, and on a
 * return from Checkout.
 * Keeps the Klaviyo Mystery Offer form active during normal browsing, but
 * immediately makes that exact form non-interactive if it appears while a
 * shopper is adding to cart, opening the cart, or proceeding to checkout.
 * 2026-10-20 (Claude, requested by Carlo): the Yes/No "Pop-Up Form // 10% Off" forms that
 * replace the Mystery Offer (SPjveC English, RfB8D6 French) get the same protection, so they
 * can never cover Add to Cart, the cart or Checkout once they are switched on in Klaviyo.
 *
 * A return from Shopify Checkout is a narrow continuation of purchase intent.
 * Suppress the form on that returned cart document only; do not persist
 * suppression across ordinary browsing or cart navigation.
 */
(function () {
  'use strict';

  if (window.__ifungiPurchaseIntentGuardLoaded) return;
  window.__ifungiPurchaseIntentGuardLoaded = true;

  var MYSTERY_FORM_ID = 'XFTsUM';
  /* 2026-10-15: XK5wSH is the French copy of the Mystery Offer (shown on /fr-ca only).
     Both forms get exactly the same purchase-intent protection. */
  /* 2026-10-20: SPjveC (English) and RfB8D6 (French) are the "Pop-Up Form // 10% Off" forms.
     They are hidden on purchase intent exactly like the Mystery Offer. */
  var MYSTERY_FORM_IDS = [MYSTERY_FORM_ID, 'XK5wSH', 'SPjveC', 'RfB8D6'];
  var MYSTERY_FORM_SELECTOR = MYSTERY_FORM_IDS.map(function (id) {
    return '[data-testid="klaviyo-form-' + id + '"]';
  }).join(',');
  var GUARD_DURATION_MS = 120000;
  var activeUntil = 0;
  var observer = null;
  var observerTimer = null;

  var intentSelector = [
    '#lf7-atc-btn',
    '#ps7-atc-btn',
    '[data-ifungi-sticky-atc]',
    '#home-sticky-atc',
    '#lf7-sticky-atc',
    '#ps7-sticky-atc',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    'a[href$="/cart"]',
    'a[href*="/cart?"]',
    '.shopify-payment-button button'
  ].join(',');

  function isActive() {
    return Date.now() < activeUntil;
  }

  function isCheckoutReturn() {
    return /\/checkouts(?:\/|$)/.test(document.referrer || '');
  }

  /* The cart page is checkout intent in itself (layout/theme.liquid also hides the form there). */
  function isCartPage() {
    return !!document.querySelector('.shopify-section--main-cart, button[name="checkout"], input[name="checkout"]');
  }

  function findMysteryDialog() {
    var form = document.querySelector(MYSTERY_FORM_SELECTOR);
    return form && form.closest ? form.closest('[role="dialog"]') : null;
  }

  function suppressMysteryOffer(attempt) {
    if (!isActive()) return false;

    var dialog = findMysteryDialog();
    if (dialog) {
      /*
       * Do not synthesize a click on Klaviyo's close button. In the mobile
       * cart drawer, that generic click enters Impact's dialog/outside-click
       * observer and closes the open cart drawer. Hiding only the exact
       * Mystery Offer root keeps the cart interaction and native Checkout
       * controls intact.
       */
      dialog.setAttribute('data-ifungi-purchase-suppressed', 'true');
      dialog.setAttribute('aria-hidden', 'true');
      dialog.style.setProperty('display', 'none', 'important');
      dialog.style.setProperty('opacity', '0', 'important');
      dialog.style.setProperty('visibility', 'hidden', 'important');
      dialog.style.setProperty('pointer-events', 'none', 'important');

      if (document.body) document.body.classList.remove('klaviyo-prevent-body-scrolling');
      document.documentElement.removeAttribute('data-ifungi-klaviyo-blocking');
      return true;
    }

    if ((attempt || 0) < 12) {
      window.setTimeout(function () { suppressMysteryOffer((attempt || 0) + 1); }, 50);
    }
    return false;
  }

  function stopObserverLater() {
    if (observerTimer) window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(function () {
      if (observer) observer.disconnect();
      observer = null;
      observerTimer = null;
      activeUntil = 0;
      document.documentElement.removeAttribute('data-ifungi-purchase-intent');
      document.documentElement.removeAttribute('data-ifungi-klaviyo-blocking');
    }, Math.max(250, activeUntil - Date.now() + 250));
  }

  function startObserver() {
    if (!window.MutationObserver || observer || !document.documentElement) return;
    observer = new MutationObserver(function () {
      if (!isActive()) return;
      if (findMysteryDialog()) {
        document.documentElement.setAttribute('data-ifungi-klaviyo-blocking', 'true');
        suppressMysteryOffer(0);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function beginPurchaseIntent(source) {
    activeUntil = Date.now() + GUARD_DURATION_MS;
    document.documentElement.setAttribute('data-ifungi-purchase-intent', source || 'purchase');
    startObserver();
    stopObserverLater();
    suppressMysteryOffer(0);
  }

  function beginFromIntentEvent(event) {
    var target = event.target && event.target.closest ? event.target.closest(intentSelector) : null;
    if (!target) return;
    var source = target.id || target.getAttribute('name') || target.getAttribute('href') || 'purchase';
    beginPurchaseIntent(source);
  }

  /* Start before `click`. Klaviyo can insert its modal between pointer-down and
     click, which makes the modal the click target and prevents the older guard
     from recognizing the shopper's Add to Cart intent. Pointer/touch capture
     closes that race; click remains as a keyboard/browser compatibility backup. */
  document.addEventListener('pointerdown', beginFromIntentEvent, true);
  document.addEventListener('touchstart', beginFromIntentEvent, { capture: true, passive: true });
  document.addEventListener('click', beginFromIntentEvent, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    beginFromIntentEvent(event);
  }, true);

  window.addEventListener('klaviyoForms', function (event) {
    var detail = event && event.detail ? event.detail : {};
    var formId = detail.formId || detail.formID || '';
    if (detail.type === 'open' && MYSTERY_FORM_IDS.indexOf(formId) !== -1) {
      if (!isActive() && isCartPage()) beginPurchaseIntent('cart-page-popup');
      if (isActive()) {
        document.documentElement.setAttribute('data-ifungi-klaviyo-blocking', 'true');
        suppressMysteryOffer(0);
      }
    }
  });

  /* Begin as soon as this deferred asset executes on the returned cart page,
     rather than waiting for pageshow, which can occur after late app widgets. */
  if (isCheckoutReturn()) beginPurchaseIntent('checkout-return');
  if (findMysteryDialog() && isCartPage()) beginPurchaseIntent('cart-page-popup-existing');

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) beginPurchaseIntent('checkout-return-bfcache');
  });

  window.__ifungiPurchaseIntentGuard = {
    version: '1.8.0',
    formId: MYSTERY_FORM_ID,
    formIds: MYSTERY_FORM_IDS.slice(),
    begin: beginPurchaseIntent,
    isActive: isActive,
    suppress: function () { return suppressMysteryOffer(0); }
  };
})();
